//초성 검색
const makeRegexByCho = (search = "") => {
    const Choseong = [
        'ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ',
        'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ',
        'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ',
        'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ',
    ];
    const StartChar = "가".charCodeAt();
    const ChoseongPeriod = Math.floor("까".charCodeAt() - "가".charCodeAt());
    const JungseongPeriod = Math.floor("개".charCodeAt() - "가".charCodeAt());

    const combine = (cho, jung, jong) => {
        return String.fromCharCode(
            StartChar + cho * ChoseongPeriod + jung * JungseongPeriod + jong
        );
    }

    const regex = Choseong.reduce(
        (acc, cho, index) =>
            acc.replace(
                new RegExp(cho, "g"),
                `[${combine(index, 0, 0)}-${combine(index + 1, 0, -1)}]`
            ),
        search
    );

    return new RegExp(`(${regex})`, "g");
};

export const includeByCho = (search, targetWord) => {
    return makeRegexByCho(search).test(targetWord);
};

export const transDate = (date) => {
    const regDate = /^\d{4}\.(0[1-9]|1[0-2])\.(0[1-9]|[12][0-9]|3[01])$/;
    const regRowDate = /^(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])$/;
    if (date.length === 10 && regDate.test(date)) {
        return date;
    }
    else if(regRowDate.test(date)) {
        const year = date.slice(0, 4);
        const month = date.slice(4, 6);
        const day = date.slice(6, 8);

        return year + "." + month + "." + day;
    }
    else {
        return "1900.01.01";
    }
};

const padZero = (value) => String(value).padStart(2, '0');

export const dateFormat = (date) => {
    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1);
    const day = padZero(date.getDate());
    const hour = padZero(date.getHours());
    const minute = padZero(date.getMinutes());

    return `${year}.${month}.${day} ${hour}:${minute}`;
};

export const convertMilliDate = (milliSecond) => {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const data = new Date(milliSecond);  // Date객체 생성
  
    const year = data.getFullYear();    // 0000년 가져오기
    const month = data.getMonth() + 1;  // 월은 0부터 시작하니 +1하기
    const date = data.getDate();        // 일자 가져오기
    const day = days[data.getDay()];    // 요일 가져오기
    let hour = data.getHours();
    if(hour < 10) {
        hour = '0' + hour;
    }
    let min = data.getMinutes();
    if(min < 10) {
        min = '0' + min;
    }
    let sec = data.getSeconds();
    if(sec < 10) {
        sec = '0' + sec;
    }
  
    return `${year}.${month}.${date}. (${day}) ${hour}:${min}:${sec}`;
};

// 값이 null 또는 undefined일 경우 true
export const checkIsNull = (data) => {    
    return data === null || data === undefined;
};

export const excludeKeys = (obj, keys) => {
    if (Array.isArray(obj)) {
        // 배열일 경우, 각 요소에 대해 재귀적으로 처리
        return obj.map(item => excludeKeys(item, keys));
    } else if (obj && typeof obj === 'object') {
        // 객체일 경우, 각 키에 대해 검사
        return Object.fromEntries(
            Object.entries(obj)
            .filter(([key]) => !keys.includes(key)) // 제외할 키를 필터링
            .map(([key, value]) => [key, excludeKeys(value, keys)]) // 값에 대해 재귀적으로 처리
        );
    }
    // 기본 타입 (문자열, 숫자 등)은 그대로 반환
    return obj;
};

export const parseToArray = (data) => {
    if (Array.isArray(data)) return data;
    if (typeof data !== 'string') return [];

    try {
        const parsedTag = JSON.parse(data);
        if (Array.isArray(parsedTag)) {
            return parsedTag;
        }
    } catch (e) {
        // JSON.parse 실패 → 일반 문자열 그대로 사용
    }
    
    return data.split(",").filter(Boolean);
};

export const parseToObject = (data) => {
    if (data && typeof data === 'object' && !Array.isArray(data)) {
        return data; // 이미 객체
    }

    if (typeof data !== 'string') return {};

    try {
        const parsed = JSON.parse(data);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            return parsed;
        }
    } catch (e) {
        // JSON.parse 실패
    }
    
    return {};
};
